import './PlansInfo.scss';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const PlansInfo = ({title, subtitle, text, image, support, price }) => {
  const navigate = useNavigate();

  const normalizedTitle = title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const handleButtonClick = (button) => {
    if (button.plan) {
      navigate(`/agenda?plan=${button.plan}`);
    } else {
      navigate(button.link);
    }
  };

  return (
    <div className={`plansInfo`} id={normalizedTitle}>
      <img src={`/images/plan/${image}`} alt="Testimonio" width="60" height="60" loading='lazy' className='plansInfo__image' />
      <div className='plansInfo__content'>
        <div className='plansInfo__content__title'>
          <h3>Plan de acompañamiento {subtitle}:</h3>
          <h2 data-aos="fade-left">{title}</h2>
        </div>
        <p className='plansInfo__content__text'>{text}</p>
        <ul>
          <li>Evaluación inicial</li>
        </ul>
        <p>Nos sumergiremos en un dialogo profundo sobre tu historia, objetivos y hábitos actuales. En este espacio seguro vas a sentirte escuchada y entendida, no juzgada.</p>
        <ul>
          <li>Plan de alimentación personalizado</li>
        </ul>
        <p>Un recurso diseñado para vos, flexible, sin prohibiciones. Para apoyarte en tu viaje hacia tu mejor versión. Vas a aprender a comer sin miedo ni culpa.</p>
        <ul>
          <li>Acompañamiento</li>
        </ul>
        <p>{support}</p>
        <p className='plansInfo__content__price' dangerouslySetInnerHTML={{ __html: price }} />
        <button onClick={() => handleButtonClick({ plan: normalizedTitle })}>Es lo que estoy buscando!</button>
      </div>
    </div>
  );
};

PlansInfo.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  support: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

export default PlansInfo;